import { React, useEffect } from "react";
import deliveryImage from "../../Assets/deliveryImage.svg";
import businessSupport from "../../Assets/businessSupport.svg";
import ITSupport from "../../Assets/ITSupport.svg";
import assetsFinances from "../../Assets/assetsFinances.svg";
import { Link } from "react-router-dom";
import { ArrowRight } from "react-bootstrap-icons";
import Aos from "aos";

const cards = [
  {
    key: 1,
    header: "Delivery Service Apps",
    description:
      "Our delivery service apps offer the following suits of service portals",
    learnMore: "Learn More",
    link: "/products",
    img: deliveryImage,
  },
  {
    key: 2,
    header: "Business Support Service",
    description:
      "We support Logistics companies through the process of obtaining their operating license with...",
    learnMore: "Learn More",
    link: "/products/businessSupport",
    img: businessSupport,
  },
  {
    key: 3,
    header: "IT Support Service",
    description:
      "Our IT support service is an IT consultation service that help the logistic companies purchase and host their own domain name",
    learnMore: "Request Service",
    link: "/",
    img: ITSupport,
  },
  {
    key: 4,
    header: "Asset Finance",
    description:
      "Our IT support service is an IT consultation service that help the logistic companies purchase and host their own domain name",
    learnMore: "Request Service",
    link: "/",
    img: assetsFinances,
  },
];

const greenStyle = {
  color: "rgba(23, 136, 82, 1)",
  fontFamily: "Proxima Nova",
  fontSize: "0.9rem",
};

const ProductsAndServices = () => {
  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);

  return (
    <section id="productsAndServices" className="container mt-4">
      <div className="row align-items-center justify-content-center">
        <div className="col-12 col-lg-4 my-auto px-4" data-aos="fade-right">
          <div className="my-3 fs-2 fw-bold">
            One Platform,
            <br />
            Many Solutions
          </div>
          <div className="mb-4 lh-5">
            Our platform offers solutions, features and the best experience that
            makes logistics seamless for you. We have everything you need.
          </div>
          <Link to="/signup">
            <button
              className={`btn btn-lg text-white fs-6`}
              type="button"
              onClick={() => {
                window.scrollTo({
                  left: 0,
                  top: 0,
                  behavior: "smooth",
                });
              }}
              style={{ background: "#28B672" }}
            >
              Get Started
            </button>
          </Link>
        </div>
        <div className="col-12 col-lg-8 my-5 px-3 align-items-center">
          <div className="row" data-aos="fade-left">
            {cards.map((card) => {
              return (
                <Link
                  className="text-decoration-none col-12 col-sm-6"
                  style={greenStyle}
                  to={card.link}
                  onClick={() => {
                    window.scrollTo({
                      left: 0,
                      top: 0,
                      behavior: "smooth",
                    });
                  }}
                >
                  <div key={card.key} className="text-black px-3">
                    <img src={card.img} alt="img" className="my-2 py-3" />
                    <div className="fs-5 fw-bold my-2">{card.header}</div>
                    <div className="mb-2">{card.description}</div>
                    <div className="mt-3 mb-4" style={greenStyle}>
                      {card.learnMore} <ArrowRight />
                    </div>
                  </div>
                </Link>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProductsAndServices;
